// Angular import

import { Component, output } from '@angular/core';

// project import
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { NavLeftComponent } from './nav-left/nav-left.component';
import { NavRightComponent } from './nav-right/nav-right.component';

@Component({
  selector: 'app-nav-bar',
  imports: [NavLeftComponent, NavRightComponent, SharedModule],
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent {
  // public props
  NavCollapsedMob = output();

  // public method
  // NOTE: deliberately NOT emitting on window:resize — mobile browsers fire
  // resize when the address bar collapses or the keyboard opens, which used
  // to toggle the sidebar randomly. Only explicit hamburger clicks emit.
  navCollapseMob() {
    if (window.innerWidth < 1025) {
      this.NavCollapsedMob.emit();
    }
  }
}
